export default {
    setMiddlewareConnectionState: (state, connectionState) => {
        return state.setIn(['general', 'state'], connectionState);
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/core.js